<!--  -->
<template>
  <div class="box main">
    <div class="w">
      <el-row :gutter="20">
        <el-col :span="4">
          <div class="daohang">
            <div :class="leiming ? xia : shang" @click="changeLoc(1)">
              <div class="tiao"></div>
              软件申请试用
            </div>
            <div :class="leiming ? shang : xia" @click="changeLoc(2)">
              <div class="tiao"></div>
              软件下载
            </div>
          </div>
          <div class="chengjuli"></div>
        </el-col>
        <el-col :span="20">
          <div class="xingxi" id="page1">
            <div class="tiao"></div>
            <i>软件申请试用</i>
          </div>
          <el-card>
            <el-form
              :model="ruleForm"
              :rules="rules"
              ref="ruleForm"
              label-width="100px"
              class="demo-ruleForm"
              label-position="top"
              size="small"
            >
              <el-form-item
                label="Customer Company Name公司名称:"
                prop="Companyname"
              >
                <el-input
                  v-model="ruleForm.Companyname"
                  placeholder="请输入公司名称"
                ></el-input>
              </el-form-item>
              <el-form-item label="Industry行业:" prop="Industry">
                <el-input
                  v-model="ruleForm.Industry"
                  placeholder="请输入行业"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="Customer Address联系地址:"
                prop="CustomerAddress"
              >
                <el-input
                  v-model="ruleForm.CustomerAddress"
                  placeholder="请输入联系地址"
                ></el-input>
              </el-form-item>
              <el-form-item
                label="Contact Person联系人姓名:"
                prop="ContactPerson"
              >
                <el-input
                  v-model="ruleForm.ContactPerson"
                  placeholder="请输入联系人姓名"
                ></el-input>
              </el-form-item>
              <el-form-item label="Phone Number联系人电话:" prop="PhoneNumber">
                <el-input
                  v-model="ruleForm.PhoneNumber"
                  placeholder="请输入联系人电话"
                ></el-input>
              </el-form-item>
              <el-form-item label="Mail Address联系人邮箱:" prop="MailAddress">
                <el-input
                  v-model="ruleForm.MailAddress"
                  placeholder="请输入联系人邮箱"
                ></el-input>
              </el-form-item>
              <el-form-item label="Machine Code机器码:" prop="MachineCode">
                <el-input
                  v-model="ruleForm.MachineCode"
                  placeholder="请输入机器码"
                ></el-input>
              </el-form-item>
              <el-link
                type="primary"
                href="./tpls/jiqitichuma-SmartEarth.exe"
                download=""
                >机器码生成下载</el-link
              >
              <!-- <img src="../../public/tpls/logo.png" alt="" /> -->

              <el-form-item label="Products申请产品:" prop="type">
                <el-checkbox-group v-model="ruleForm.type">
                  <el-checkbox
                    label="TerraExplorer Pro"
                    name="type"
                  ></el-checkbox
                  ><br />
                  <el-checkbox label="PhotoMesh" name="type"></el-checkbox
                  ><br />
                  <el-checkbox label="TerraBuilder" name="type"></el-checkbox
                  ><br />
                  <el-checkbox label="CityBuilder" name="type"></el-checkbox>
                </el-checkbox-group>
              </el-form-item>
              <el-form-item label="申请理由:" prop="ReasonApplication">
                <el-input
                  type="textarea"
                  v-model="ruleForm.ReasonApplication"
                  placeholder="请输入申请理由"
                ></el-input>
              </el-form-item>
              <el-form-item label="备注">
                <el-input type="textarea" v-model="ruleForm.Note"></el-input>
              </el-form-item>
              <p style="width:60%">
                注释：默认软件版本为V7，如需其它版本产品，请写明试用产品模块及版本号。
                Duration: 30days（测试时间，默认30天） Reason For Evaluation
                Request: 注明申请测试软件用途
              </p>

              <el-form-item class="btn">
                <el-button type="primary" @click="submit()">提交确认</el-button>
              </el-form-item>
            </el-form>
          </el-card>
          <div class="xingxi" style="margin-top: 60px;" id="page2">
            <div class="tiao"></div>
            <i>软件下载</i>
          </div>
          <el-card>
            <div class="xiazai">
              <iframe
                src="http://www.skylineglobe.cn/downloadcenter.aspx?ProductID=74"
                width="1050"
                height="2000"
                frameborder="0"
                scrolling="yes"
                style="width:1050px;height:2000px;margin:-350px 0px 0px -270px;"
              ></iframe>
            </div>
          </el-card>
        </el-col>
      </el-row>
    </div>
  </div>
</template>

<script>
export default {
  //import引入的组件需要注入到对象中才能使用
  components: {},
  data() {
    //这里存放数据
    return {
      leiming: false,
      shang: "shang yanse",
      xia: "shang",
      application: {
        host: "parallelword@terra-it.cn",
        title: "软件申请",
        content: ""
      },
      ruleForm: {
        Companyname: "",
        Industry: "",
        CustomerAddress: "",
        ContactPerson: "",
        PhoneNumber: "",
        MailAddress: "",
        MachineCode: "",
        type: [],
        ReasonApplication: "",
        Note: ""
      },
      rules: {
        Companyname: [
          { required: true, message: "请输入公司名称", trigger: "blur" }
        ],
        Industry: [{ required: true, message: "请输入行业", trigger: "blur" }],
        CustomerAddress: [
          { required: true, message: "请输入联系地址", trigger: "blur" }
        ],
        ContactPerson: [
          { required: true, message: "请输入联系人姓名", trigger: "blur" }
        ],
        PhoneNumber: [
          { required: true, message: "请输入联系人电话", trigger: "blur" }
        ],
        MailAddress: [
          { required: true, message: "请输入联系人邮箱", trigger: "blur" }
        ],
        MachineCode: [
          { required: true, message: "请输入机器码", trigger: "blur" }
        ],
        type: [
          {
            required: true,
            message: "请选择Products申请产品",
            trigger: "change"
          }
        ],
        ReasonApplication: [
          { required: true, message: "请输入申请理由", trigger: "blur" }
        ]
      }
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
  },
  destroyed() {
    //离开这个界面之后，删除，不然会有问题
    window.removeEventListener("scroll", this.handleScroll);
  },
  //方法集合
  methods: {
    handleScroll() {
      var scrollTop =
        document.documentElement.scrollTop || document.body.scrollTop;
      // console.log(scrollTop);
      if (scrollTop >= 1300) {
        this.leiming = true;
      }
      if (scrollTop < 1300) {
        this.leiming = false;
      }
      // console.log(scrollTop);
    },
    changeLoc(key) {
      // 获取点击的按钮对应页面的id
      var PageId = document.querySelector("#page" + key);
      // 使用平滑属性，滑动到上方获取的距离
      // 下方我只设置了top，当然 你也可以加上 left 让他横向滑动
      // widow 根据浏览器滚动条，如果你是要在某个盒子里面产生滑动，记得修改
      // console.log(PageId.className);

      window.scrollTo({
        top: PageId.offsetTop,
        behavior: "smooth"
      });
    },

    submit() {
      this.$refs.ruleForm.validate(valid => {
        if (valid === true) {
          this.$confirm("确认要提交吗?", "提交", {
            confirmButtonText: "确定",
            cancelButtonText: "取消",
            type: "warning"
          })
            .then(async () => {
              var content = `<h3>试用申请单</h3><b>Customer Company Name公司名称:</b> ${
                this.ruleForm.Companyname
              } <br /><b>Industry行业:</b> ${
                this.ruleForm.Industry
              } <br /><b>Customer Address联系地址:</b>  ${
                this.ruleForm.CustomerAddress
              } <br /><b>Contact Person联系人姓名:</b> ${
                this.ruleForm.ContactPerson
              } <br /><b>Phone Number联系人电话:</b> ${
                this.ruleForm.PhoneNumber
              } <br /><b>Mail Address联系人邮箱:</b> ${
                this.ruleForm.MailAddress
              } <br /><b>Machine Code机器码:</b> ${
                this.ruleForm.MachineCode
              } <br /><b>Products申请产品:</b> ${this.ruleForm.type.toString()} <br /><b>申请理由:</b> ${
                this.ruleForm.ReasonApplication
              }<br /><b>备注:</b> ${this.ruleForm.Note}`;
              this.application.content = content;
              const { data: dt } = await this.$http.post(
                "general/sendMail",
                this.application
              );
              if (dt.status !== 200) {
                return this.$message.error(dt.msg);
              }
              this.$refs.ruleForm.resetFields();
              this.$message({
                message: "提交成功",
                type: "success"
              });
            })
            .catch(() => {});
        }
      });
    }
  }
};
</script>
<style lang="less" scoped>
//@import url(); 引入公共css类
.el-button {
  width: 50%;
  height: 40px;
}
.el-form-item {
  width: 60%;
}
.yanse {
  background-color: #d6d6d3;
  .tiao {
    width: 4px;
    height: 30px;
    border-radius: 30px;
    background: rgba(0, 134, 253, 1);
    display: inline-block;
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
  }
}
.chengjuli {
  height: 150px;
}
.daohang {
  width: 180px;
  height: 150px;
  background-color: #fff;
  position: fixed;
  // top: 0px;
  // left: 0px;
  // z-index: 1;
  margin: 0;
  cursor: pointer;
  .shang {
    height: 50%;

    text-align: center;
    line-height: 75px;
    position: relative;
  }
  .shang:hover {
    background-color: #d6d6d3;
    .tiao {
      width: 4px;
      height: 30px;
      border-radius: 30px;
      background: rgba(0, 134, 253, 1);
      display: inline-block;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
  .xia {
    height: 50%;

    text-align: center;
    line-height: 75px;
    position: relative;
  }
  .xia:hover {
    background-color: #d6d6d3;
    .tiao {
      width: 4px;
      height: 30px;
      border-radius: 30px;
      background: rgba(0, 134, 253, 1);
      display: inline-block;
      position: absolute;
      left: 0;
      top: 50%;
      transform: translateY(-50%);
    }
  }
}
.xiazai {
  width: 800px;
  height: 760px;
  overflow: hidden;
  // margin-top: 80px;
}
.xingxi {
  //   width: 90px;
  margin-bottom: 20px;
  //   margin-top: 40px;
  //   position: absolute;
  //   left: 50px;
  //   top: 60px;

  .tiao {
    width: 4px;
    height: 15px;
    background: rgba(0, 134, 253, 1);
    display: inline-block;
    margin-right: 10px;
  }
  i {
    // width: 65px;
    font-weight: bold;
    font-size: 16px;
  }
}
.main {
  margin-top: 60px;
  background-color: rgba(245, 245, 245);
  padding-top: 40px;
  padding-bottom: 100px;
  box-sizing: border-box;
}
/* 版心 */
.w {
  width: 1190px;
  margin: 0 auto;
  // position: relative;
}
i {
  font-style: normal;
}
li {
  list-style-type: none;
}
ul {
  margin: 0;
  padding: 0;
}
.box {
  width: 100%;
  height: 100%;
}
</style>
